import { useEffect, useRef } from 'react'

export const useRefValue = <T>(value: T): React.MutableRefObject<T> => {
  const refValue = useRef(value)
  useEffect(() => {
    refValue.current = value
  })
  return refValue
}
